import React, { useCallback, useContext, useMemo, useRef, useState } from "react";
import { graphql, useStaticQuery, withPrefix } from "gatsby";
import classNames from "classnames";
import { Link } from "./atoms/link";
import Icon from "./atoms/icon";
import Button from "./atoms/button";
import RevooBadge from "./atoms/reevoo-badge";
import ProductTag from "./modules/product-tag";
/* import NotificationEcommerce from "./modules/notification-ecommerce"; */
import useWhereToBuy from "../hooks/use-where-to-buy";
import CompareContext from "./context/compare";
import { CDN_BASE_URL } from "../utility/constants";
import { isOldEnergyLabel } from "../utility/energy-label-link";
import placeholderImg from "../images/placeholder.png";
import ProductPrice from "./molecules/product-price";
import useStoreLocator from "../utility/use-store-locator";
import { productClick } from "../utility/data-layer";
import ButtonWTB from "./atoms/button-wtb";
import useReevooTrack from "../utility/use-reevoo-track";
import RepairabilityIndex from "../components/atoms/repairability-index";
import { hasEcommerce } from "../utility/ecommerce";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import CartContext from "./context/cart";
import { getResultTags } from "../utility/discount-tag";
import addUtm from "../utility/add-utm";
import AccessoriesAndConsumablesModal from "./accessories-and-consumables-modal";
// import babelConfig from "../../babel-config.json";
import useEnergyLabelLink from "../utility/use-energy-label-link";

const ProductCard = (product, location) => {
  const {
    productName,
    key_prod,
    lineId,
    pageLine,
    energyClass,
    familiesIds,
    productDescBefore,
    minicard4,
    priceData,
    productLink,
    shopLink,
    productTags,
    // notificationEcommerce,
    isSingleProdInList,
    compare,
    campaignTag,
    showPrice,
    isCompare,
    origin,
    index,
    repairabilityIndex,
    assetId,
    // isSliderProd,
    madeProductLineId,
    originComponent,
    productApp,
    badge,
    bannerPromo,
    liferayProductNotes,
    extraServices,
    brandName,
    productTitleNoFamilyAC,
    page,
    isPlp,
    onHide,
  } = product;
  const {
    config,
    labelManagerLabels,
    site: { siteMetadata },
  } = useStaticQuery(graphql`
    {
      config: liferayGeneralConfiguration {
        isElMarket
        currency
        isReevooActive
        priceType
        tagActive
        tagColor
        tagvalue
        tagTextPosition
        invertProductFamily
      }
      site {
        siteMetadata {
          priceLanguage
        }
      }
      labelManagerLabels: labelManagerLabels {
        plpShowLess
        plpShowMore
        buyOnHooverShop
        foundRetailers
        buyNow
        showProduct
        addToComparison
        removeFromComparison
        pricePercentageTooltip
        changeModel
        addToCart
        save
        goToProductPage
        productPreview
        close
      }
    }
  `);

  const pathPrefix = withPrefix("/");

  const [accessoriesAndConsumablesState, setAccessoriesAndConsumablesState] = useState(false);
  const closeModal = () => {
    setAccessoriesAndConsumablesState(false);
  };

  const accessoriesAndConsumablesCheck =
    !!madeProductLineId &&
    madeProductLineId !== 333 &&
    lineId === 333 &&
    originComponent === "Related product - PDP";

  const { toggleProduct, productIds, removeProduct } = useContext(CompareContext);
  const toggleCompare = useCallback((e) => toggleProduct(e.currentTarget.name), [toggleProduct]);
  const images = product.primaryimage;
  const img = images.filter((image) => image.imageType === "640")[0] || {
    imageUrl: placeholderImg,
  };

  const { isElMarket } = config;

  const energyClassImg = useMemo(() => {
    return energyClass
      ? `${CDN_BASE_URL}/classe-energetica/${
          isOldEnergyLabel(isElMarket, lineId) ? "el" : "nel"
        }/${encodeURIComponent(energyClass)}.svg`
      : null;
  }, [energyClass, isElMarket, lineId]);

  const LANG = useMemo(
    () => siteMetadata.priceLanguage.split("-")[0].toUpperCase(),
    [siteMetadata.priceLanguage]
  );

  const energyClassUrl = useEnergyLabelLink(product, LANG, config, 0);

  const productFamily = familiesIds && familiesIds.length ? familiesIds[0] : null;
  const altImage = productFamily?.title + " " + key_prod;
  const productDescription = productDescBefore
    ? productDescBefore
    : minicard4?.length
    ? minicard4.slice(0, 5).join(", ")
    : "";

  const lineProductName = pageLine?.pageNameInCardProdotto
    ? pageLine?.pageNameInCardProdotto
    : pageLine?.pageName;

  const productTitle =
    lineId === 333 && !(familiesIds?.length > 0) && productTitleNoFamilyAC
      ? productTitleNoFamilyAC
      : productFamily?.title;

  const reevooTrack = useReevooTrack(key_prod);
  const whereToBuyAssetId = useWhereToBuy(assetId);
  const omnibusPriceTag = priceData?.omnibusPrice?.[0]?.value
    ? JSON?.parse(priceData?.omnibusPrice?.[0]?.value)?.amount
    : null;
  const tags = useMemo(() => {
    return getResultTags(campaignTag, productTags, config, priceData, 2, omnibusPriceTag);
  }, [campaignTag, config, priceData, productTags, omnibusPriceTag]);

  const storeLocatorPage = useStoreLocator();

  const clickDetail = useCallback(
    () => productClick(product, priceData, origin, index),
    [product, priceData, origin, index]
  );

  const repairabilityIndexParsed = priceData?.repairabilityIndex?.[0]?.value
    ? JSON.parse(priceData.repairabilityIndex?.[0].value)
    : null;

  const { addProduct, adding, loadingCart } = useContext(CartContext);
  const onAddCart = useCallback(
    () => addProduct(product, null, location, origin),
    [addProduct, product, location, origin]
  );

  const refWtb = useRef();
  const onClickWtb = () => refWtb.current?.click?.();

  const noRetailerPageCountryMap = new Map([
    ["/it_IT/", "hoover.it"],
    ["/fr_FR/", "hoover.fr"],
    ["/de_DE/", "hoover.de"],
    ["/en_GB/", "hoover.uk"],
    ["/pl_PL/", "hoover.pl"],
    ["/nl_BE/", "hoover.be"],
    ["/fr_BE/", "hoover.be"],
    ["/nl_NL/", "hoover.nl"],
    ["/bg_BG/", "hoover.bg"],
    ["/fr_CH/", "hoover.ch"],
    ["/de_CH/", "hoover.ch"],
    ["/it_CH/", "hoover.ch"],
    ["/es_ES/", "hoover.es"],
    ["/el_GR/", "hoover.gr"],
    ["/ru_RU/", "hoover.ru"],
    ["/cs_CZ/", "hoover.cz"],
    ["/sk_SK/", "hoover.sk"],
    ["/tr_TR/", "hoover.tr"],
    ["/pt_PT/", "hoover.pt"],
    ["/sl_SI/", "hoover.sl"],
    ["/hr_HR/", "hoover.hr"],
    ["/en_IE/", "hoover.ie"],
    ["/ro_RO/", "hoover.ro"],
    ["/rs_SR_latin/", "hoover.rs"],
    ["/hu_HU/", "hoover.hu"],
    ["/uk_UA/", "hoover.ua"],
    ["/no_NO/", "hoover.no"],
    ["/da_DK/", "hoover.dk"],
    ["/fi_FI/", "hoover.fi"],
    ["/sv_SE/", "hoover.se"],
    ["/lv_LV/", "hoover.lv"],
    ["/lt_LT/", "hoover.lt"],
    ["/fr_MA/", "hoover.ma"],
  ]);

  const noRetailerPage = pageLine?.docConfiguration?.includes("retailer page");

  const checkLocatorCountry = (pathPrefix) => {
    if (pathPrefix === "/nl_BE/" || pathPrefix === "/nl_NL/") {
      return "nl";
    }
    if (pathPrefix === "/fr_BE/" || pathPrefix === "/fr_FR/" || pathPrefix === "/fr_CH/") {
      return "fr";
    }
    if (pathPrefix === "/de_DE/" || pathPrefix === "/de_CH/") {
      return "de";
    }
    if (pathPrefix === "/es_ES/") {
      return "es";
    }
    if (pathPrefix === "/it_IT/" || pathPrefix === "/it_CH/") {
      return "it";
    }
    if (pathPrefix === "/pl_PL/") {
      return "pl";
    }
    if (pathPrefix === "/pt_PT/") {
      return "pt";
    } else {
      return "en";
    }
  };

  const storeLocatorPageAC = `https://www.premiumservicesforhoover.eu/${checkLocatorCountry(
    pathPrefix
  )}/${key_prod}/?utm_source=${noRetailerPageCountryMap.get(
    pathPrefix
  )}&utm_medium=referral&utm_campaign=always_on_brand_website`;
  const storeLocatorPageCP = `https://www.premiumservicesforcareplusprotect.eu/${checkLocatorCountry(
    pathPrefix
  )}/${key_prod}/?utm_source=${noRetailerPageCountryMap.get(
    pathPrefix
  )}&utm_medium=referral&utm_campaign=always_on_brand_website`;

  const storeLink =
    noRetailerPage && brandName === "Hoover"
      ? storeLocatorPageAC
      : noRetailerPage && brandName === "Care-Protect"
      ? storeLocatorPageCP
      : null;

  return (
    <>
      <div className="product-card" key={key_prod}>
        {tags?.length > 0 && (
          <div className="product-card__tags">
            {tags.map((tag) => (
              <ProductTag
                data={tag}
                key={tag.id}
                config={config}
                labelManagerLabels={labelManagerLabels}
                siteMetadata={siteMetadata}
              />
            ))}
          </div>
        )}
        <div>
          <Link
            to={accessoriesAndConsumablesCheck ? null : productLink}
            onClick={
              accessoriesAndConsumablesCheck
                ? () => setAccessoriesAndConsumablesState(true)
                : () => {
                    onHide();
                    clickDetail();
                  }
            }
            state={{ origin }}
            title={productName}
          >
            <div className="product-card__image">
              {img.gatsbyImageData ? (
                <GatsbyImage image={getImage(img)} alt={altImage} />
              ) : (
                <img src={img.imageUrl} alt={altImage} />
              )}
            </div>
          </Link>
          {(energyClassUrl && energyClassImg) ||
          !!repairabilityIndex?.[0] ||
          (hasEcommerce && priceData?.shopLink && priceData?.repairabilityIndex?.[0]?.value) ? (
            <div
              className={classNames(
                "product-card__class",
                energyClass && `product-card__class--${energyClass.toLowerCase()}`,
                (!!repairabilityIndex?.[0] ||
                  (hasEcommerce &&
                    priceData?.shopLink &&
                    priceData?.repairabilityIndex?.[0]?.value)) &&
                  "product-card__class-energy-repairability"
              )}
            >
              {config.isReevooActive?.[0] === "yes" ? (
                <RevooBadge productId={key_prod} />
              ) : (
                <div></div>
              )}
              <div className="product-card__class--container">
                {energyClassUrl && energyClassImg && (
                  <Link
                    to={energyClassUrl}
                    target="_blank"
                    rel="noreferrer"
                    className={"product-card__class-energy"}
                  >
                    <img
                      src={energyClassImg}
                      alt={energyClass}
                      className="product-card__class-energy-img"
                    />
                  </Link>
                )}
                {(!!repairabilityIndex?.[0] ||
                  (hasEcommerce &&
                    priceData?.shopLink &&
                    priceData?.repairabilityIndex?.[0]?.value)) && (
                  <RepairabilityIndex
                    lineId={product.lineId}
                    data={
                      repairabilityIndex?.[0]?.product?.filter((item) => item.sku === key_prod)[0]
                    }
                    origin="product-card"
                    indexValue={
                      repairabilityIndexParsed?.value
                        ? repairabilityIndexParsed.value?.replace(".", ",")
                        : null
                    }
                    link={
                      hasEcommerce && priceData?.pdfRepairabilityLink
                        ? priceData.pdfRepairabilityLink
                        : null
                    }
                  />
                )}
              </div>
            </div>
          ) : (
            <div className="product-card__class--empty"></div>
          )}
          <Link
            to={accessoriesAndConsumablesCheck ? null : productLink}
            onClick={
              accessoriesAndConsumablesCheck
                ? () => setAccessoriesAndConsumablesState(true)
                : () => {
                    onHide();
                    clickDetail();
                  }
            }
            state={{ origin }}
          >
            <div className="product-card__info">
              <div className="product-card__name--container">
                <span className="product-card__name" title={lineProductName}>
                  {" "}
                  {lineProductName}{" "}
                </span>
                {isPlp ? (
                  <h2 className="product-card__name--h2" title={productTitle}>
                    {productTitle && productTitle}
                  </h2>
                ) : (
                  <h3 className="product-card__name--h3" title={productTitle}>
                    <span className="product-card__familyName">{productTitle && productTitle}</span>
                  </h3>
                )}
              </div>
              <div className="product-card__name">
                <span className="product-card__sku" title={productName}>
                  {" "}
                  {productName}{" "}
                </span>
              </div>
              {productDescription && (
                <span className="product-card__description" title={productDescription}>
                  {productDescription}
                </span>
              )}
            </div>
          </Link>
        </div>
        {/* {notificationEcommerce?.length > 0 ? (
          <NotificationEcommerce data={notificationEcommerce[0]} />
        ) : null} */}
        {priceData && <ProductPrice data={priceData} index={index} />}
        <label
          className={classNames(
            "product-card__compare",
            !(!isCompare && !compare && productIds && !isSingleProdInList && lineId !== 333) &&
              "product-card__compare--noborder"
          )}
        >
          {!isCompare && !compare && productIds && !isSingleProdInList && lineId !== 333 && (
            <>
              <span>
                {productIds.includes(key_prod)
                  ? labelManagerLabels.removeFromComparison
                  : labelManagerLabels.addToComparison}
              </span>
              <input
                className={classNames("product-card__compare-button button", {
                  "product-card__compare-button--active": productIds.includes(key_prod),
                })}
                checked={productIds.includes(key_prod)}
                name={key_prod}
                onChange={toggleCompare}
                type="checkbox"
              />
            </>
          )}
        </label>

        <div className="product-card__buttons">
          {priceData?.sellingPrice && !shopLink ? (
            <button
              onClick={onAddCart}
              disabled={!!adding || loadingCart}
              className="button primary blue"
            >
              {labelManagerLabels.addToCart}
              <Icon name="system-cart" />
            </button>
          ) : shopLink ? (
            <Link
              to={hasEcommerce && priceData?.shopLink ? addUtm(priceData?.shopLink) : shopLink}
              className="button primary blue"
              key="shoplink"
            >
              {labelManagerLabels.buyOnHooverShop}
              <Icon name="system-cart" />
            </Link>
          ) : null}
          {whereToBuyAssetId ? (
            <ButtonWTB
              className={classNames(
                "cswidget button primary wtb-card",
                shopLink || showPrice || priceData?.sellingPrice ? "white" : "blue"
              )}
              key="wtb"
              label={labelManagerLabels.foundRetailers || labelManagerLabels.buyNow}
              reevooTrack={reevooTrack}
              sku={key_prod}
              assetId={whereToBuyAssetId}
              ref={refWtb}
              iconName="system-pin"
              storeLink={storeLink}
            />
          ) : (
            storeLocatorPage && (
              <Button
                data={{
                  label: labelManagerLabels.foundRetailers || labelManagerLabels.buyNow,
                  link: !!storeLink ? storeLink : storeLocatorPage,
                  target: !!storeLink ? "_blank" : "_self",
                }}
                className={classNames(
                  "button primary wtb-card wtb-card--sl-page",
                  shopLink || showPrice || priceData?.sellingPrice ? "white" : "blue"
                )}
                key="wtb"
                iconName="system-pin"
              ></Button>
            )
          )}
        </div>
        {!isCompare && compare && (
          <div className="product-card__buttons-compare">
            <Link
              to={page?.link ? page.link : pageLine.link}
              className="change-button"
              onClick={() => removeProduct(key_prod)}
            >
              <span>{labelManagerLabels.changeModel || "Change model"}</span>
              <Icon name="symbols-change" />
            </Link>
            <button className="remove-button" onClick={() => removeProduct(key_prod)}>
              {labelManagerLabels.removeFromComparison} <Icon name="symbols-close" />
            </button>
          </div>
        )}
        {accessoriesAndConsumablesState && (
          <AccessoriesAndConsumablesModal
            show={accessoriesAndConsumablesState}
            onHide={closeModal}
            babelProdotto={
              priceData
                ? {
                    ...product,
                    shopLink:
                      hasEcommerce && priceData?.shopLink
                        ? addUtm(priceData?.shopLink)
                        : priceData.shopLink || product.shopLink,
                  }
                : product
            }
            config={config}
            location={location}
            labelManagerLabels={labelManagerLabels}
            siteMetadata={siteMetadata}
            priceData={priceData}
            app={productApp}
            tags={tags}
            badge={badge}
            bannerPromo={bannerPromo}
            liferayProductNotes={liferayProductNotes}
            extraServices={extraServices}
            onClickWtb={onClickWtb}
            storeLink={storeLink}
          />
        )}
      </div>
    </>
  );
};

export default ProductCard;
